const pre_study_questions = {
    big5: {
        Big1: "… is reserved",
        Big2: "… is generally trusting",
        Big3: "… tends to be lazy",
        Big4: "… is relaxed, handles stress well",
        Big5: "… has few artistic interests",
        Big6: "… is outgoing, sociable",
        Big7: "… tends to Wnd fault with others",
        Big8: "… does a thorough job",
        Big9: "… gets nervous easily",
        Big10: "… has an active imagination",

    },
    nfc:{
        nfc1:"I would prefer complex to simple problems",
        nfc2: "I like to have the responsibility of handling a situation that requires a lot of thinking",
        nfc3: "Thinking is not my idea of fun",
        nfc4: "I would rather do something that requires little thought than something that is sure to challenge my thinking abilities",
        nfc5: "I really enjoy a task that involves coming up with new solutions to problems",
        nfc6: "I would prefer a task that is intellectual, difficult, and important to one that is somewhat important but does not require much thought"
    },

    habit: {
        Disposition1: "I surf the net whenever I have the opportunity.",
        Disposition2: "If I can choose, I prefer digital media resources while studying in the library.",
        Disposition3: "I do not spend time reading the news from the newspaper to follow daily occasions.",
        Disposition6: "I follow social media news websites like twitter to get instant information for the events.",
        Disposition7: "I think that electronic reading devices are beneficial for reading habits.",
        Disposition8: "I like reading news over digital media such as tablets in my free time.",
        Disposition9: "Reading from e-books is more tiring than reading from the printed books.",
    },

    media_use:{
        use1: "How often do you get news from print newspapers?",
        use2: "How often do you get news from news websites or apps?",
        use3: "How often do you get news from social media platforms?",
    }
}

export {pre_study_questions}
